module.exports = __webpack_public_path__ + "img/u=3137863005,4227718428&fm=26&gp=0.e2e9c4ba.jpg";